import { Outlet } from 'react-router-dom';

export function LeavesLayout() {
  return <Outlet />;
}
